import { BookingChannelAPI } from "../api";

export class BookingChannel {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getBookingChannels(projectId) {
    const { data } = await BookingChannelAPI.getBookingChannels(projectId);
    return data.result.map((item) => new BookingChannel(item));
  }
  static async createBookingChannel(formData) {
    const { data } = await BookingChannelAPI.createBookingChannel(formData);
    return new BookingChannel(data.result);
  }
  static async updateBookingChannel(formData) {
    const { data } = await BookingChannelAPI.updateBookingChannel(formData);
    return new BookingChannel(data.result);
  }
  static async removeBookingChannel(id) {
    const { data } = await BookingChannelAPI.removeBookingChannel(id);
    return new BookingChannel(data.result);
  }
}
